import { getPublicConfig } from "@/shared/config/config"
import type { HttpClient } from "@/shared/types/HttpClient"
import type { CreateDeploymentRequest } from "../types/CreateDeploymentRequest"
import type { DeploymentResponse, DeploymentsResponse } from "../types/DeploymentResponse"

const { cmApiBaseUrl } = getPublicConfig()
const apiBaseUrl = `${cmApiBaseUrl}/v1/deployments`

export const createDeploymentApi = (client: HttpClient) => ({
  createDeployment: async (
    parent: string,
    parentId: string,
    module: string,
    deploymentId: string,
    request: CreateDeploymentRequest
  ): Promise<DeploymentResponse> =>
    client.post<DeploymentResponse>(`${apiBaseUrl}/${parent}/${parentId}/${module}/${deploymentId}/form`, request)
})

export const getDeploymentStatusApi = (client: HttpClient) => ({
  getDeploymentStatus: async (parent: string, id: string, module: string): Promise<DeploymentsResponse> =>
    client.get<DeploymentsResponse>(`${apiBaseUrl}/${parent}/${id}/${module}`)
})
